import React, { useContext, useMemo } from 'react';
import { Accordion, List, ThemeIcon, Text, Box } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Trip } from '../../lib/interfaces';
import { TSDate } from '../../lib/time';
import { TripProblem, findProblemsForTrip } from '../../lib/problems';
import { AllTripActivitiesContext } from '../../lib/context';

export function ProblemsList({ trips }: { trips: Trip[] }) {

    const allTripActivities = useContext(AllTripActivitiesContext);
    const problems = useMemo(
          () => trips.flatMap(trip => findProblemsForTrip(trip,
               Array.from(allTripActivities.allActivities.values()).filter(p => p.tripdocid === trip.docid))),
          [ trips, allTripActivities ]);

    const grouped = useMemo(() => problems.reduce((acc, problem) => {
            const title = problem.trip.title ?? 'Untitled Trip';
            if (!acc[title]) acc[title] = [];
            acc[title].push(problem);
            return acc;
        }, {} as Record<string, TripProblem[]>),
        [ problems ]);

   if (problems.length === 0) {
        return <Text p="md" color="dimmed">No problems detected!</Text>;
    }

    return (
        <Accordion multiple variant="contained" mt="md">
            {Object.entries(grouped).map(([tripTitle, tripProblems]) => (
                <Accordion.Item key={tripTitle} value={tripTitle}>
                    <Accordion.Control icon={<IconAlertTriangle size={16} color="orange" />}>
                        {tripTitle} ({tripProblems.length})
                    </Accordion.Control>
                    <Accordion.Panel>
                        <List spacing="xs" size="sm" listStyleType="none">
                            {tripProblems.map((p, i) => {
                                const isFuture = p.day?.isAfter(TSDate.today());
                                return (
                                    <List.Item key={i} style={{ 
                                        padding: '4px',
                                        borderRadius: '4px',
                                        color: isFuture ? 'inherit' : 'var(--mantine-color-dimmed)'
                                    }}>
                                        <Text size="sm">
                                            {p.type === 'draft-item' ? 'Draft: ' : 'Lodging: '}
                                            {p.description.replace(new RegExp(`^.*: `), '')}
                                        </Text>
                                    </List.Item>
                                );
                            })}
                        </List>
                    </Accordion.Panel>
                </Accordion.Item>
            ))}
        </Accordion>
    );
}
